/**
 * Generic function to remove accents, uppercase and special characthers
 * @param text
 */
function removeAccentMarkAndUppercase(text) {
  var lowerCaseString = text.toLowerCase().trim(),
    chars = { á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u', ñ: 'n' },
    regExp = /[áéíóúñ]/gi;
  var noAccentString = lowerCaseString.replace(regExp, function (e) {
    return chars[e];
  });
  var noBreakLinesRegExp = /\r?\n|\r/g;
  var noBreakLinesString = noAccentString.replace(noBreakLinesRegExp, ' ');

  return noBreakLinesString;
}

export default removeAccentMarkAndUppercase;
